export default __webpack_public_path__ + "static/media/Sheet.f015a519.svg";